import theme from '@styles/theme';

const CircleCheckmarkFilled = ({
  width = 16,
  height = 16,
  stroke = theme.palette.color[2],
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path 
      d="M8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5ZM11.208 5.64648C10.9859 5.42454 10.6429 5.39697 10.3906 5.56348L10.2891 5.64648L6.89941 9.03516L5.66504 7.80078L5.5625 7.7168C5.31026 7.5505 4.96712 7.57884 4.74512 7.80078C4.52322 8.02296 4.49546 8.36596 4.66211 8.61816L4.74512 8.71973L6.45117 10.4258L6.55371 10.5088C6.80587 10.6751 7.14809 10.6475 7.37012 10.4258C7.40373 10.3922 7.43232 10.3548 7.45703 10.3164L11.208 6.56641C11.4618 6.31256 11.4618 5.9003 11.208 5.64648Z" 
      fill={stroke}
    />
  </svg>
);


export { CircleCheckmarkFilled };
